export default "__VITE_ASSET__DwS1UAIL__"